<template>
  <mp-box v-if="metas.total >= 1" my="4" w="full">
    <mp-flex justify-content="space-between">
      <mp-flex v-if="!isSimple" align-items="center">
        <template v-if="isRow">
          <mp-text color="gray.600" line-height="md" padding-right="1" padding-y="1">
            Rows per page
          </mp-text>
          <mp-popover :id="`${prefixId}rows-popover`" ref="dropdownLimit" placement="bottom-start">
            <mp-tooltip label="Result per page" position="bottom">
              <mp-popover-trigger>
                <mp-button
                  :is-disabled="disabled"
                  variant="unstyled"
                  display="inline-flex"
                  size="sm"
                  h="5"
                  pl="1"
                  pr="1"
                  :_hover="{
                    bg: 'ice.50',
                  }"
                >
                  <mp-text font-weight="600" line-height="md">{{ limit }}</mp-text>
                  <mp-icon name="caret-down" size="sm" />
                </mp-button>
              </mp-popover-trigger>
            </mp-tooltip>
            <mp-popover-content max-width="13" bg="white" rounded="md" shadow="lg" outline="1px solid" outline-color="gray.400" z-index="10">
              <mp-popover-list>
                <mp-popover-list-item v-for="lmt in limits" :key="lmt" :value="lmt" @click="updateLimit(lmt)">{{ lmt }}</mp-popover-list-item>
              </mp-popover-list>
            </mp-popover-content>
          </mp-popover>
        </template>
        <mp-text color="gray.600" line-height="md" :padding-left="isRow ? '5' : '2'" padding-y="1">
          Showing {{ metas.from }} - {{ metas.to }} of {{ formatCurrency(metas.total) }}
        </mp-text>
      </mp-flex>
      <mp-flex align-items="center" :w="isSimple ? '100%' : ''">
        <mp-box
          ><mp-input
            v-model="tempCurrentPage"
            placeholder="Page"
            :is-disabled="disabled"
            type="number"
            w="48px"
            h="28px"
            min-h="28px"
            min-w="48px!important"
            max-w="120px"
            py="4px!important"
            resize="none"
            @blur="updatePage($event)"
            @keyup.enter="updatePage($event)"
            @input.native="resizeWidth"
        /></mp-box>
        <mp-text color="gray.600" line-height="md" padding-left="2" padding-right="4" padding-y="1">
          of {{ formatCurrency(metas.last_page) }} page
        </mp-text>
        <mp-box ml="auto">
          <!-- Prev Page -->
          <mp-tooltip label="Prev page" position="bottom">
            <mp-button-icon
              name="chevrons-left"
              size="sm"
              border-radius="full"
              padding-right="1"
              :disabled="disabled || metas.current_page == 1"
              @click="clickPage(metas.current_page - 1)"
            />
          </mp-tooltip>

          <!-- Next Page -->
          <mp-tooltip label="Next page" position="bottom">
            <mp-button-icon
              name="chevrons-right"
              size="sm"
              border-radius="full"
              padding-left="1"
              :disabled="disabled || metas.current_page == metas.last_page"
              @click="clickPage(metas.current_page + 1)"
            />
          </mp-tooltip>
        </mp-box>
      </mp-flex>
    </mp-flex>
  </mp-box>
</template>

<script>
import { formatCurrency } from '@/helpers/number';

const DEFAULT_INPUT_WIDTH = '48px';

export default {
  name: 'Pagination',
  props: {
    prefixId: {
      type: String,
      default: '',
    },
    isSimple: {
      type: Boolean,
      default: false,
    },
    isRow: {
      type: Boolean,
      default: true,
    },
    metas: {
      type: Object,
      default: () => {
        return {
          current_page: 1,
          last_page: 1,
          per_page: 10,
          from: 1,
          to: 1,
          total: 1,
        };
      },
      validator(value) {
        return value.current_page && value.last_page && value.per_page && value.total >= 0;
      },
    },
    limits: {
      type: Array,
      default: () => {
        return [10, 20, 50, 100];
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      limit: this.metas.per_page || 10,
      page: this.metas.current_page,
      tempCurrentPage: this.metas.current_page,
    };
  },
  watch: {
    'metas.per_page': function(newValue, oldValue) {
      if (+newValue !== +oldValue) this.limit = newValue;
    },
    limit(newValue, oldValue) {
      if (+newValue !== +oldValue) this.$emit('update', { page: 1, limit: newValue });
    },
    page(newValue, oldValue) {
      if (this.tempCurrentPage !== newValue) this.tempCurrentPage = newValue;
      if (+newValue !== +oldValue) this.$emit('update', { page: newValue, limit: this.limit });
    },
    'metas.current_page': function(newValue, oldValue) {
      if (+newValue !== +oldValue) this.page = +newValue;
    },
  },
  mounted() {
    const inputElement = this.$el.querySelector?.('input');
    if (inputElement) {
      inputElement.dispatchEvent(
        new Event('input', {
          bubbles: true,
          cancelable: true,
        }),
      );
    }
  },
  methods: {
    formatCurrency,
    clickPage(number) {
      this.page = number;
    },
    updateLimit(limit) {
      this.$refs.dropdownLimit.closePopover();
      this.limit = limit;
    },
    updatePage(event) {
      if (this.page !== this.tempCurrentPage) {
        event.target.style.width = DEFAULT_INPUT_WIDTH;
        setTimeout(() => this.resizeWidth(event), 300);
      }

      const page = +this.tempCurrentPage;
      if (!page || page < 1 || page > this.metas.last_page || Number.isNaN(page)) this.tempCurrentPage = this.page;
      else this.page = page;
    },
    resizeWidth(event) {
      const { scrollWidth } = event.target;
      event.target.style.width = `${scrollWidth + 4}px`;
    },
  },
};
</script>
